import { ProtectedPage } from "@/components/misc/protected";
import { Breadcrumb } from "@/components/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/warehouse")({
  component: () => (
    <ProtectedPage requires="org:warehouse:warehouse_read">
      <Breadcrumb label="Warehouse" to="/warehouse">
        <Outlet />
      </Breadcrumb>
    </ProtectedPage>
  ),
});
